export default [
    "10 10",
    '<circle cx="5" cy="5" r="5" fill="#FEDF89"/>' +
    '<circle cx="5" cy="5" r="3.75" fill="#FEC84B"/>' +
    '<circle cx="5" cy="5" r="2.5" fill="#FDB022"/>'
]
